'use strict';

/* global $ */

const processInclude = require('progamers_core/util');
const initPopOver = require('progamers_core/components/initPopOver');
const { handleNotifyMe } = require('progamers_core/notifyme/backInStock');
const { showToastMessage } = require('progamers_core/components/toast');
const productTilePlaceholder = require('progamers_core/components/productTilePlaceholder');

/**
 * Shows a toast response message based on the AJAX response.
 * @param {Object} response - The server response object.
 */
function showResponseMsg(response) {
    $.spinner().stop();
    var alertType = response.success ? 'alert-success' : 'alert-danger';

    showToastMessage({
        message: response.msg,
        alertType: alertType
    });
}

/**
 * Sends an AJAX request to update the public status of a wishlist or item.
 * @param {string} listID - The wishlist list ID.
 * @param {string} itemID - The wishlist item ID.
 * @param {Function} callback - Callback invoked after the request completes.
 */
function updatePublicStatus(listID, itemID, callback) {
    var url = document.getElementById('isPublicList').getAttribute('data-url');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            listID: listID,
            itemID: itemID
        },
        success: function (data) {
            if (callback && data.success) {
                callback();
            }
            showResponseMsg(data, null);
        },
        error: function (err) {
            if (callback) {
                callback();
            }
            showResponseMsg(err);
        }
    });
}

/**
 * Attaches click listener to public item checkboxes in the wishlist container.
 */
function addPublicItemCheckboxListener() {
    const wishlistContainer = document.querySelector('.js-wishlist-container');
    wishlistContainer?.addEventListener('click', function (event) {
        if (event.target.classList.contains('js-hide-from-public')) {
            event.preventDefault();
            event.stopPropagation();
            const checkbox = event.target;
            const itemID = checkbox.dataset.id;
            var resetCheckBox = function () {
                if (checkbox.checked) {
                    checkbox.checked = false;
                } else {
                    checkbox.checked = true;
                }
                return checkbox.checked;
            };
            if (checkbox.getAttribute('id') !== null && checkbox.getAttribute('id') === 'isPublicList') {
                updatePublicStatus(itemID, null, resetCheckBox);
            } else {
                updatePublicStatus(null, itemID, resetCheckBox);
            }
        }
    });
}

/**
 * Attaches click listeners to all remove-from-wishlist buttons.
 */
function addRemoveItemButtonListener() {
    const removeItemButton = document.querySelectorAll('.remove-from-wishlist');
    removeItemButton.forEach(btn => {
        btn.removeEventListener('click', btn);
        btn.addEventListener('click', function () {
            $.ajax({
                url: btn.dataset.url,
                type: 'get',
                success: function (data) {
                    if (typeof window.checkResponseForEventDetails === 'function') {
                        window.checkResponseForEventDetails(data);
                    }
                    window.location.href = btn.dataset.redirect;
                },
                error: function (err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                }
            });
        });
    });
}

/**
 * Attaches click listener to the load more button on the wishlist page.
 */
function addLoadMoreListener() {
    const wishlistLoadMoreButton = document.getElementById('wlLoadMore');
    if (wishlistLoadMoreButton) {
        wishlistLoadMoreButton.addEventListener('click', () => {
            var pageNumber = document.getElementById('wishlistItemCards').getAttribute('data-page-number');
            // eslint-disable-next-line no-use-before-define
            renderNewPageOfItems(pageNumber, wishlistLoadMoreButton);
        });
    }
}

/**
 * Attaches click listeners for the share link modal and copy link functionality.
 */
function copyLinkListener() {
    const $copyLinkModalTrigger = $('#js-wishlist-shareLinkModalBtn');
    const $copyLinkModal = $('#shareLinkModal');
    const $copyLinkTrigger = $('#js-copy-link-btn');

    if ($copyLinkModalTrigger && $copyLinkTrigger) {
        $copyLinkModalTrigger.on('click', () => {
            const shareUrl = $copyLinkModalTrigger.attr('data-url');
            const $shareLinkInput = $('#js-share-link-input');
            $shareLinkInput.val(shareUrl);
            $copyLinkModal.modal('show');
        });

        $copyLinkTrigger.bind('click', () => {
            const $shareLinkInput = $('#js-share-link-input');
            $shareLinkInput.select();
            document.execCommand('copy');
            $copyLinkModal.modal('hide');
            const messageCopySuccess = $copyLinkModalTrigger.attr('data-message-copy-success');
            if (messageCopySuccess) {
                showToastMessage({
                    message: messageCopySuccess,
                    alertType: 'alert-success'
                });
            }
        });
    }
}

/**
 * Fetches and renders the next page of wishlist items.
 * @param {string} pageNumber - The current page number.
 * @param {HTMLElement} button - The load more button element.
 */
function renderNewPageOfItems(pageNumber, button) {
    var data = document.getElementById('wishlistItemCards');
    var publicView = data.getAttribute('data-public-view');
    var listUUID = data.getAttribute('data-uuid');
    var url = data.getAttribute('data-href');
    var newPageNumber = Number(pageNumber) + 1;
    var loadMoreWrapper = document.querySelector('.js-more-wl-items-col');

    if (button) {
        button.setAttribute('disabled', 'true');
        button.querySelector('.js-more-wl-items-loader')?.classList.remove('d-none');
    }

    if (loadMoreWrapper) {
        loadMoreWrapper.insertAdjacentHTML('beforebegin', productTilePlaceholder(6));
    }

    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    })
        .done(function (_data) {
            // note: jquery html() method can execute <script> from response (e.g. tracking script)
            // (js innerHTML would render it as plain text e.g <script rendered as &lt;script)
            $('#wishlistWrapper').html(_data);

            addRemoveItemButtonListener();
            addLoadMoreListener();
            copyLinkListener();
            initPopOver();

            if (button) {
                button.setAttribute('disabled', 'false');
                button.querySelector('.js-more-wl-items-loader')?.classList.add('d-none');
            }
            document.querySelectorAll('.product-tile-placeholder').forEach(el => el.remove());
        })
        .fail(function () {
            $('.more-wl-items').remove();
        });
}

$(document).ready(function () {
    addPublicItemCheckboxListener();
    addRemoveItemButtonListener();
    addLoadMoreListener();
    copyLinkListener();
    handleNotifyMe();
    processInclude(require('progamers_core/components/scrollToTop'));
});

module.exports = {
    /**
     * Disables the update wishlist button when the product is not ready to order.
     */
    updateWishlistUpdateButton: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            response.$productContainer.find('.btn-update-wishlist-product').attr('disabled', !response.product.readyToOrder || !response.product.available);
        });
    }
};
